const WidgetInfo = {
    get: (widget) => {
        if (!widget || !widget.data) return {};
        const defaultValue = "Default";
        return {
            renderAlignment: widget.data.renderAlignment ?? defaultValue,
            renderTheme: widget.data.renderTheme ?? defaultValue,
            renderLocation: widget.data.renderLocation ?? "main",
        };
    },
};

export default WidgetInfo;
